module.exports = "<div class=\"app-pix-withdraw-change\">\n\t<app-main-title title=\"Pix Saque e Troco\" subtitle=\"Agora você pode sacar dinheiro com o Pix\"></app-main-title>\n\t<app-pix-withdraw-change-menu></app-pix-withdraw-change-menu>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/withdraw-change.component.html
// module id = ../../../../../src/app/master/pix/withdraw-change/withdraw-change.component.html
// module chunks = main